import { computed } from 'mobx';

export default class RoleModel {
  id;
  store;

  constructor(store, role) {
    this.store = store;
    this.id = +role.id;
    this.name = role.name;
    this.description = role.description;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
  }
}



// WEBPACK FOOTER //
// ./src/models/RoleModel.js